<template>
  <div class="user-search">
    <TopPanel
      @sort-order="userSearchStore.setSortOrder"
      @sort-option="userSearchStore.sort"
      :sort-options="sortOptions"
      :searchQuery="searchQuery"
    >
      <template v-slot:left-side>
        <h1><span>Search results</span></h1>
      </template>
    </TopPanel>
    <h2>Collections ({{ userSearchStore.data?.[0]?.count || 0 }})</h2>
    <template v-if="userSearchStore.data?.[0]?.count !== undefined">
      <ElementsGrid>
        <OneCollection
          v-for="collection in userSearchStore.data[0].rows"
          :key="collection.id"
          :collection="collection"
        />
      </ElementsGrid>
    </template>
    <h2>Designs ({{ userSearchStore.data?.[1]?.count || 0 }})</h2>
    <template v-if="userSearchStore.data?.[1]?.count !== undefined">
      <ElementsGrid>
        <OneDesign
          v-for="design in userSearchStore.data[1].rows"
          :key="design.id"
          :design="design"
          :collection-id="design.collection.toString()"
        />
      </ElementsGrid>
    </template>
    <h2>Fit Models ({{ userSearchStore.data?.[2]?.count || 0 }})</h2>
    <template v-if="userSearchStore.data?.[2]?.count !== undefined">
      <ElementsGrid>
        <OneFitModel
          v-for="fitChart in userSearchStore.data[2].rows"
          :key="fitChart._id"
          :fit-chart="fitChart"
        />
      </ElementsGrid>
    </template>
    <h2>Fit Charts ({{ userSearchStore.data?.[3]?.count || 0 }})</h2>
    <template v-if="userSearchStore.data?.[3]?.count !== undefined">
      <ElementsGrid>
        <OneCustomFitChart
          v-for="fitChart in userSearchStore.data[3].rows"
          :key="fitChart._id"
          :fit-chart="fitChart"
        />
      </ElementsGrid>
    </template>
    <ExpiredDemoMode />
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useUserSearchStore } from '@/store/pinia/userSearch'

import TopPanel from '@/components/UserCollections/TopPanel.vue'
import ElementsGrid from '@/components/Atoms/ElementsGrid.vue'
import OneCollection from '@/components/UserCollections/OneCollection.vue'
import OneDesign from '@/components/UserCollections/OneDesign.vue'
import OneFitModel from '@/components/fitCharts/OneFitModel.vue'
import OneCustomFitChart from '@/components/fitCharts/OneCustomFitChart.vue'
import ExpiredDemoMode from '@/components/ExpiredDemoMode.vue'

export default {
  name: 'UserCollections',
  components: {
    ExpiredDemoMode,
    TopPanel,
    ElementsGrid,
    OneCollection,
    OneDesign,
    OneFitModel,
    OneCustomFitChart,
  },
  computed: {
    ...mapStores(useUserSearchStore),
  },
  data: () => ({
    searchQuery: '',
    sortOptions: [
      { name: 'Sort by', value: '' },
      { name: 'Name', value: 'title' },
      { name: 'Last edited', value: 'updatedAt' },
    ],
  }),
  methods: {
  },
  async beforeMount () {
    const { q = '' } = this.$route.query
    this.userSearchStore.params.q = q
    this.searchQuery = q
    await this.userSearchStore.getData()
  },
}
</script>

<style lang="scss">
.user-search {
  padding: 0 16px 40px 40px;

  h1 {
    color: var(--text_color);
    font-family: Unbounded;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    margin-bottom: 16px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      display: none;
    }
  }

  h2 {
    color: var(--text_color, #1D1F29);
    font-family: Unbounded;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin: 40px 0 24px 0;

    &:first-child {
      margin-top: 24px;
    }
  }

  .elements-grid .edit-menu-button {
    display: none;
  }
}

@media (max-width: 760px) {
  .user-search {
    padding: 0 0 40px 0 !important;

    h1 {
      font-size: 24px !important;
    }
  }
}

@media (min-width: 761px) and (max-width: 1194px) {
  .user-search {
    h1 {
      margin-bottom: 0;
    }

    .user-top-panel {
      .left-side {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
